var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import Checkbox from "../Checkbox";
export default function getColumns(rowSelection, data, getRowKey, columns) {
    var _a = useState((rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.selectedRowKeys) || []), selectedRows = _a[0], setSelectedRows = _a[1];
    var _b = useState((rowSelection === null || rowSelection === void 0 ? void 0 : rowSelection.selectedRowKeys.length) === data.length && !!data.length), selectAll = _b[0], setSelectAll = _b[1];
    if (rowSelection) {
        var getCheckboxProps_1 = rowSelection.getCheckboxProps;
        return __spreadArray([
            {
                dataIndex: "checkbox",
                key: "checkbox",
                title: (_jsx(Checkbox, { onChange: function (e) {
                        var _a;
                        var mergedRows = e.currentTarget.checked
                            ? data
                                .filter(function (dt) {
                                var disabledCheckboxes = getCheckboxProps_1 === null || getCheckboxProps_1 === void 0 ? void 0 : getCheckboxProps_1(dt);
                                return !(disabledCheckboxes === null || disabledCheckboxes === void 0 ? void 0 : disabledCheckboxes.disabled);
                            })
                                .map(function (dt) { return getRowKey(dt); })
                            : [];
                        setSelectedRows(mergedRows);
                        (_a = rowSelection.onChange) === null || _a === void 0 ? void 0 : _a.call(rowSelection, mergedRows);
                        setSelectAll(e.currentTarget.checked);
                    }, checked: selectAll })),
                width: "50px",
                render: function (_, item) {
                    var _a;
                    return (_jsx(Checkbox, __assign({ onChange: function (e) {
                            var _a;
                            var mergedRows = null;
                            if (!e.currentTarget.checked) {
                                setSelectAll(false);
                                mergedRows = selectedRows.filter(function (row) { return row !== getRowKey(item); });
                            }
                            else {
                                mergedRows = Array.from(new Set(__spreadArray(__spreadArray([], selectedRows, true), [getRowKey(item)], false)));
                                if (mergedRows.length === data.length)
                                    setSelectAll(true);
                            }
                            setSelectedRows(mergedRows);
                            (_a = rowSelection.onChange) === null || _a === void 0 ? void 0 : _a.call(rowSelection, mergedRows);
                        }, checked: selectedRows.includes(getRowKey(item)) }, (((_a = rowSelection.getCheckboxProps) === null || _a === void 0 ? void 0 : _a.call(rowSelection, item)) || {}))));
                },
            }
        ], columns, true);
    }
    return columns;
}
